import React from 'react';

export const FlagBRIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 900 600" // Standard 3:2 ratio
    {...props}
  >
    <rect width="900" height="600" fill="#009B3A" rx="2"/> {/* Green field */}
    <path d="M450 50 L850 300 L450 550 L50 300 Z" fill="#FEDD00" /> {/* Yellow rhombus */}
    <circle cx="450" cy="300" r="175" fill="#002776" /> {/* Blue circle */}
    {/* Simplified banner - a white curved path */}
    <path d="M180,320 Q450,250 720,320" stroke="#FFFFFF" strokeWidth="25" fill="none" />
    {/* Simplified stars - a few white dots */}
    <circle cx="450" cy="270" r="10" fill="#FFFFFF" />
    <circle cx="420" cy="340" r="8" fill="#FFFFFF" />
    <circle cx="480" cy="340" r="8" fill="#FFFFFF" />
    <circle cx="390" cy="290" r="6" fill="#FFFFFF" />
    <circle cx="510" cy="290" r="6" fill="#FFFFFF" />
  </svg>
);